import * as MC from "@mantine/core";
import { Fragment, useState } from "react";
import { NavLink } from "react-router-dom";

import { Functionality } from "@app/services/category/types";
import { getEnvs } from "../utils/getEnvs";

import { useAuthentication } from "@app/store/useAuthtentication";
import { useDeliveryData } from "@app/store/useDeliverySearchData";
import { useGenericData } from "@app/store/useGenericData";
import { getExternalUrl } from "@app/utils/getExternalUrl";
import { historyRedirect } from "@app/utils/historyRedirect";
import { capitalizeFirst, moduleInfo, normalizeText } from "../utils/utils";
import "./styles.scss";

interface ISidebarLinkProps {
  label: string;
  links: Functionality[];
}

const env = getEnvs();

export default function HomeLink(props: ISidebarLinkProps) {
  const [isOpen, setIsOpen] = useState(false);
  const clearDataDispense = useDeliveryData((store) => store.clearDataDispense);
  const { dataBiowel, allCategory } = useAuthentication((store) => store.auth);
  const { siteId, siteName } = useGenericData((store) => store.genericData);

  const onClickLink = () => {
    setIsOpen((state) => !state);
    clearDataDispense();
  };

  const onNavigateExternalUrl = (url: string) => {
    window.location.href = `${env.URL_PROTOCOL}${env.URL_BASE}${url}`;
  };

  const renderSubLinks = () => {
    return props.links.map((elem, idx) => (
      <Fragment key={elem.id}>
        {elem.url.includes("/dispensation") ? (
          <NavLink
            to={elem.url}
            className="home-link"
            data-testid={`homelink-dispensation-navlink-${idx}`}
          >
            {capitalizeFirst(elem.name)}
          </NavLink>
        ) : elem.isExternal ? (
          <div
            className="home-link pointer"
            onClick={(e) => {
              e.preventDefault();
              historyRedirect({
                path: `${getExternalUrl({
                  allCategory,
                  dataBiowel,
                  category: moduleInfo(elem.url, allCategory)
                })}?goTo=${elem.path}&params=${encodeURIComponent(
                  JSON.stringify({
                    siteId,
                    siteName
                  })
                )}`,
                isInternal: false,
                useQueryParams: true
              });
            }}
            data-testid={`category-item-${normalizeText(props.label)}-${normalizeText(elem.name)}-link`}
          >
            {capitalizeFirst(elem.name)}
          </div>
        ) : (
          <div
            className="home-link"
            onClick={() => onNavigateExternalUrl(elem.url)}
            data-testid={`category-item-${normalizeText(props.label)}-${normalizeText(elem.name)}-link`}
          >
            {capitalizeFirst(elem.name)}
          </div>
        )}
      </Fragment>
    ));
  };

  const renderComponent = () => {
    return (
      <>
        <MC.UnstyledButton
          className="category-item"
          onClick={onClickLink}
          data-testid={`category-item-${normalizeText(props.label)}`}
        >
          <MC.Title py={0} order={5}>
            {capitalizeFirst(props.label)}
          </MC.Title>
        </MC.UnstyledButton>
        {props.links.length > 0 ? (
          <MC.Collapse in={isOpen} style={{ whiteSpace: "nowrap" }} mb="md">
            {renderSubLinks()}
          </MC.Collapse>
        ) : null}
      </>
    );
  };

  return renderComponent();
}
